import { render, staticRenderFns } from "./ManageBookingIndex.vue?vue&type=template&id=476593a6&scoped=true"
import script from "./ManageBookingIndex.vue?vue&type=script&lang=js"
export * from "./ManageBookingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476593a6",
  null
  
)

export default component.exports